/* Bastar Arts — facets.js
   Collection/search filtering + sorting via Section Rendering API (no reloads).
   Compatible with Shopify Search & Discovery filters. */
(function () {
  'use strict';

  const form = document.getElementById('FacetFiltersForm');
  const grid = document.getElementById('ProductGridContainer');
  if (!grid) return;

  let controller = null;

  function serialize() {
    const params = new URLSearchParams();
    document.querySelectorAll('form[data-facet-form]').forEach((f) => {
      new FormData(f).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
    });
    const sort = document.querySelector('[data-sort-by]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    const q = new URLSearchParams(window.location.search).get('q');
    if (q) params.set('q', q);
    return params.toString();
  }

  function renderPage(searchParams, updateHistory) {
    grid.classList.add('is-loading');
    if (controller) controller.abort();
    controller = new AbortController();
    const sectionId = grid.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    fetch(url, { signal: controller.signal })
      .then((r) => r.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        ['#ProductGridContainer', '#ActiveFacets', '#FacetCount'].forEach((sel) => {
          const target = document.querySelector(sel);
          const source = html.querySelector(sel);
          if (target && source) target.innerHTML = source.innerHTML;
        });
        /* refresh facet option counts without clobbering open/checked state the user is mid-way through */
        document.querySelectorAll('[data-facet-group]').forEach((target) => {
          const source = html.querySelector(`[data-facet-group="${target.dataset.facetGroup}"]`);
          if (source) target.innerHTML = source.innerHTML;
        });
        grid.classList.remove('is-loading');
        if (updateHistory) window.history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`);
        const count = document.querySelector('#FacetCount');
        if (count && window.BA) BA.announce(count.textContent.trim());
      })
      .catch((err) => {
        if (err.name !== 'AbortError') grid.classList.remove('is-loading');
      });
  }

  document.addEventListener('change', (e) => {
    if (e.target.closest('form[data-facet-form]') || e.target.matches('[data-sort-by]')) {
      renderPage(serialize(), true);
    }
  });

  /* Price range: debounce typing */
  let priceTimer;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-facet-price]')) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(() => renderPage(serialize(), true), 600);
  });

  /* Active filter chips + clear-all (delegated: chips re-render) */
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-facet-remove]');
    if (!chip) return;
    e.preventDefault();
    const url = new URL(chip.href, window.location.origin);
    renderPage(url.searchParams.toString(), true);
  });

  window.addEventListener('popstate', (e) => {
    renderPage((e.state && e.state.searchParams) || window.location.search.replace(/^\?/, ''), false);
  });

  /* keep the facet form present even when it's the mobile drawer copy */
  if (!form) return;
})();
